module.exports = __webpack_public_path__ + "static/media/nibuwa.e2361aee.ogg";